import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const RedemptionsReportRoute = lazyWithRetries(() => import('./redemptionSummary'))
const EngagementReportRoute = lazyWithRetries(() => import('./engagement'))
const AwardsReportRoute = lazyWithRetries(() => import('./awardSummary'))
const ReportSharingRoute = lazyWithRetries(() => import('./reportSharing'))
const AllReportsRoute = lazyWithRetries(() => import('./all'))
const ManagerLeaderboardRoute = lazyWithRetries(() => import('./managerLeaderboard'))
const RecognitionActivityReportRoute = lazyWithRetries(() => import('./recognitionActivity'))
const LiabilitiesReportRoute = lazyWithRetries(() => import('./pointsLiabilities'))
const AllocationUtilizationReportRoute = lazyWithRetries(() => import('./allocationUtilization'))
const PointsTransactionsReportRoute = lazyWithRetries(() => import('./pointsReporting'))
const RedemptionTransactionsReportRoute = lazyWithRetries(() => import('./redemptionsReport'))
const EngagementActivityReportRoute = lazyWithRetries(() => import('./engagementActivity'))
const IncentiveActivityRoute = lazyWithRetries(() => import('./incentiveActivity'))
const AwardActivityReportRoute = lazyWithRetries(() => import('./awardActivity'))
const EngagementByTeamReportRoute = lazyWithRetries(() => import('./engagementByTeam'))
const EngagementByManagerReportRoute = lazyWithRetries(() => import('./engagementByManager'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.allReports(),
    element: (
      <StandardPageLayout maxWidth={1080} elementId="allReportsRoute" title={<T _str="Reports" />}>
        <Suspense fallback={<RouteLoading />}>
          <AllReportsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('redemptionSummary'),
    element: (
      <StandardPageLayout elementId="redemptionsReportRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <RedemptionsReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports(':type?', 'share', ':tab?', ':subTab?'),
    element: (
      <StandardPageLayout
        maxWidth={1080}
        elementId="reportSharingRoute"
        title={<T _str="Report sharing" />}>
        <Suspense fallback={<RouteLoading />}>
          <ReportSharingRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('engagement'),
    element: (
      <StandardPageLayout elementId="engagementReportRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <EngagementReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('engagementByTeam'),
    element: (
      <StandardPageLayout elementId="engagementByTeamRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <EngagementByTeamReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('engagementByManager'),
    element: (
      <StandardPageLayout elementId="engagementByManagerRoute" maxWidth="100%">
        <Suspense fallback={<RouteLoading />}>
          <EngagementByManagerReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('awardSummary'),
    element: (
      <StandardPageLayout elementId="awardsReportRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <AwardsReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('managerLeaderboard'),
    element: (
      <StandardPageLayout elementId="managerLeaderboardRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <ManagerLeaderboardRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('recognitionActivity'),
    element: (
      <StandardPageLayout elementId="recognitionActivity" maxWidth="100%">
        <Suspense fallback={<RouteLoading />}>
          <RecognitionActivityReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('liabilities'),
    element: (
      <StandardPageLayout elementId="liabilitiesReportRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <LiabilitiesReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('allocationUtilization'),
    element: (
      <StandardPageLayout elementId="allocationUtilizationReportRoute" maxWidth="100%">
        <Suspense fallback={<RouteLoading />}>
          <AllocationUtilizationReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('pointsTransactions'),
    element: (
      <StandardPageLayout elementId="pointsTransactionsReportRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <PointsTransactionsReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('redemptionTransactions'),
    element: (
      <StandardPageLayout elementId="redemptionTransactionsReportRoute" maxWidth="100%">
        <Suspense fallback={<RouteLoading />}>
          <RedemptionTransactionsReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('engagementActivity'),
    element: (
      <StandardPageLayout elementId="engagementActivity" maxWidth="100%">
        <Suspense fallback={<RouteLoading />}>
          <EngagementActivityReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('incentivesActivity'),
    element: (
      <StandardPageLayout elementId="incentiveActivity" maxWidth="100%">
        <Suspense fallback={<RouteLoading />}>
          <IncentiveActivityRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.reports('awardActivity'),
    element: (
      <StandardPageLayout elementId="awardActivity" maxWidth="100%">
        <Suspense fallback={<RouteLoading />}>
          <AwardActivityReportRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
